module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAOVBMVEUAAAAbvOsaueYfvOkfuekeueoeu+oguusfuukfuuofuukfueofuuofuuoeuuoeuukfuukfu+ofuuo6ajLAAAAAEnRSTlMAJig5OoeHia2tru7u8fP09vayP2YyAAAAdElEQVRIx+2VQQ6AIAwEQVFApeL+/7EePFVDkRgTYzonUjoJ7KE1RrmPDYQyFLpz/wyZxXIhoEbgAgFOeLADiFcAiF+83P9H8Hk4zpyykJHbBL+NbYLGqrFqrB8VCOjl2Zp4JVand3y4H4yNq9Cepk6X9KvsEvAlwuMe9N8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/makeVoroStand/imgs/属性.png
// module id = 47Sw
// module chunks = 2